import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  toggleUserFormModal,
  setDeleteUserConfirmation,
} from 'store/entities/users';

import { mdiPencil, mdiTrashCan } from '@mdi/js';
import { IconButton } from 'components/UIComponents/Button';

export default () => {
  const dispatch = useDispatch();
  const { userDetails } = useSelector(state => state.auth);
  const { t } = useTranslation();
  const columns = useMemo(
    () => [
      {
        Header: t('datagate.external.users.firstName'),
        accessor: 'publicUserDto.firstName',
      },
      {
        Header: t('datagate.external.users.lastName'),
        accessor: 'publicUserDto.lastName',
      },
      {
        Header: t('datagate.external.users.username'),
        accessor: 'publicUserDto.username',
        disableSortBy: true,
      },
      {
        Header: t('datagate.external.users.table.column.actions'),
        disableSortBy: true,
        Cell: ({ row: { original } }) => {
          return (
            <div className="table__actions table__actions--start">
              <IconButton
                path={mdiPencil}
                type="button"
                aria-label="Edit user modal button"
                aria-haspopup="dialog"
                onClick={() =>
                  dispatch(
                    toggleUserFormModal({ action: 'EDIT', userData: original })
                  )
                }
              />
              {userDetails?.userId !== original?.publicUserDto.id && (
                <IconButton
                  path={mdiTrashCan}
                  type="button"
                  aria-label="Delete user modal button"
                  aria-haspopup="dialog"
                  onClick={() =>
                    dispatch(
                      setDeleteUserConfirmation({ open: true, value: original })
                    )
                  }
                />
              )}
            </div>
          );
        },
      },
    ],
    [t, userDetails, dispatch]
  );

  return columns;
};
